import React, { useEffect, useState } from "react";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  control: {
    [theme.breakpoints.down("sm")]: {
      padding: "3%",
    },
  },
  main: {
    paddingTop: "10%",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "32%",
    },
  },
}));

function PopularDestinations(props) {
  const classes = useStyles();
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadDestinations = async () => {
    setLoading(true);
    let response = await axios.get(
      "https://api.skypicker.com/umbrella/v2/graphql?featureName=OriginDestinationInterlinkingQuery&query=query+OriginDestinationInterlinkingQuery%28+%24locale%3A+Locale+%24limit%3A+Int+%29+%7B+topPopularODLandingPages%28locale%3A+%24locale%2C+limit%3A+%24limit%29+%7B+...PopularFlights_data+%7D+%7D+fragment+PopularFlightCard_data+on+ODLandingPage+%7B+origin+%7B+__typename+name+slugEn+id+%7D+destination+%7B+__typename+legacyId+name+slugEn+id+%7D+%7D+fragment+PopularFlights_data+on+ODLandingPage+%7B+...PopularFlightCard_data+origin+%7B+__typename+id+%7D+destination+%7B+__typename+id+%7D+%7D&variables=%7B%22locale%22%3A%22us%22%2C%22limit%22%3A36%7D"
    );

    if (
      response &&
      response.data &&
      response.data.data.topPopularODLandingPages
    ) {
      setDestinations(response.data.data.topPopularODLandingPages);
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   loadDestinations();
  // }, []);

  const handleOnClick = (item) => {
    let originCode = item.origin.id;
    let originName = item.origin.name;

    if (originCode.includes(":")) {
      originName = originCode.split(":")[1];
    }
    props.onSelect &&
      props.onSelect({
        start: { code: originName, name: item.origin.name },
        end: { code: item.destination.legacyId, name: item.destination.name },
      });
  };
  return (
    <div
      style={{ textAlign: "left", marginTop: "25px", display: "none" }}
      className={classes.control}
    >
      <Typography
        variant="h6"
        style={{ color: "var(--darker)", textTransform: "capitalize" }}
      >
        {" "}
        Popular Routes
      </Typography>

      <Typography
        component="p"
        style={{
          color: "var(--darker)",
          textTransform: "capitalize",
          color: "var(--lighttextcolor)",
        }}
      >
        {" "}
        Check these popular destinations on travelpick.
      </Typography>

      <div style={{ padding: "10px 0px" }}>
        <Grid container>
          {destinations &&
            destinations.map((item, id) => {
              return item && item.destination ? (
                <Grid key={id} item xs="12" sm="12" md="4">
                  <div
                    className="popular-destination"
                    onClick={() => handleOnClick(item)}
                  >
                    <div style={{ flex: 2 }}>
                      <div
                        className="thumb"
                        style={{
                          background: `url("https://images.skypicker.com/?image=https%3A%2F%2Fimages.kiwi.com%2Fphotos%2F385x320%2F${item.destination.legacyId}.jpg&amp;fit=cover&amp;width=132&amp;height=88")`,
                        }}
                      ></div>
                    </div>
                    <div style={{ flex: 3 }}>
                      <div className="text">
                        <div style={{ padding: "10px" }}>
                          <Typography
                            component="p"
                            style={{ color: "var(--darker)", fontSize: 14 }}
                          >
                            {" "}
                            {item.origin && item.origin.name} {roundTrip}{" "}
                            {item.destination && item.destination.name}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              ) : (
                <></>
              );
            })}
        </Grid>
      </div>
    </div>
  );
}

export default PopularDestinations;

const roundTrip = (
  <span class="VfPpkd-kBDsod" aria-hidden="true">
    <svg
      enableBackground="new 0 0 24 24"
      height="20"
      viewBox="0 0 24 24"
      width="20"
      focusable="false"
      className=" NMm5M hhikbc"
      fill={"var(--darker)"}
    >
      <g>
        <rect fill="none" height="24" width="24" x="0"></rect>
      </g>
      <g>
        <g>
          <polygon points="8.41,12.41 7,11 2,16 7,21 8.41,19.59 5.83,17 21,17 21,15 5.83,15"></polygon>
          <polygon points="15.59,11.59 17,13 22,8 17,3 15.59,4.41 18.17,7 3,7 3,9 18.17,9"></polygon>
        </g>
      </g>
    </svg>
  </span>
);
